<template>
  <Steps>
    <SwapableStep>
      <Title :index="4">{{ $t(title) }}</Title>
      <StepText v-if="showRawHTML" :rawHTML="$t(text)" />
      <StepText v-else>{{ $t(text) }} </StepText>
    </SwapableStep>
  </Steps>
</template>
<script>
import Steps from '../Steps/Index.vue';
import SwapableStep from '../Steps/SwappableStep.vue';
import Title from '../Steps/Title.vue';
import StepText from '../Steps/Text.vue';

function getTitleAndText(city) {
  switch (city.toUpperCase()) {
    case 'WAALRE': {
      return {
        title: 'process.step_4_title.option2',
        text: 'process.step_4_text_1.option2',
      };
    }
    default: {
      return {
        title: 'process.step_4_title.option1',
        text: 'process.step_4_text_1.option1',
      };
    }
  }
}
export default {
  components: { Steps, SwapableStep, Title, StepText },
  data() {
    return {
      ...getTitleAndText(this.city),
    };
  },
  computed: {
    showRawHTML() {
      return this.city.toUpperCase() !== 'WAALRE';
    },
  },
  props: ['city'],
};
</script>
